import { Component, EventEmitter, Input, Output } from 'ng-metadata/core';

import './tags.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentTags
 * @module mw.components.contentDocuments
 *
 * @param {array} [tags] - An array containing your tags
 * @param {expression} [on-remove-tag] - A function that will be passed in which will be invoked when you want to remove the tag
 * @param {expression} [on-tag-click] - Angular expression to evaluate when the tag is clicked. $event is the ng-click event.
 *
 * @description
 * `<mw-content-document-tags>` is responsible for display all tags associated with your content
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-tags tags="{{['tags one', 'tags two']}}> </mw-content-document-tags>
 */
@Component({
    selector: 'mw-content-document-tags',
    template: `
    <div ng-if="$ctrl.tags.length" class="mw-content-document-tags" layout="row" flex layout-wrap>
        <div class="mw-content-document-tags__tag" ng-repeat="tag in $ctrl.tags" ng-click="$ctrl.handleTagClick(tag)">
            <div layout="row">
                <div class="mw-content-document-tags__content">
                    <span style="padding-right: 5px"> {{::tag}} </span>
                </div>
                <div class="mw-content-document-tags__button-container" ng-click="$ctrl.handleRemoveTagClick(tag)">
                    <button class="mw-content-document-tags__remove-tag md-primary">
                        <md-icon class="mw-content-document-tags__icon" md-svg-icon="navigation:ic_close_24px"></md-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
    `
})

export class TagsComponent {
    @Input('<') tags: Array<string>;
    @Output() onRemoveTag = new EventEmitter<string>();
    @Output() onTagClick = new EventEmitter<string>();

    constructor() {}

    handleRemoveTagClick(tag: string) {
        this.onRemoveTag.emit(tag);
    }

    handleTagClick(tag: string) {
        this.onTagClick.emit(tag);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/tags/tags.component.ts